import { AppContainer } from '@crx-dev/hss-react-components';
import React, { useState, useEffect } from 'react';
import { matchPath, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import RegistersList from './Areas/ControlledDrugsRegister/Registers/RegistersList';
import CreateRegisterForm from './Areas/ControlledDrugsRegister/Registers/forms/CreateRegisterForm';
import Register from './Areas/ControlledDrugsRegister/Register/Register';
import CreateManualRegisterForm from './Areas/ControlledDrugsRegister/Registers/forms/CreateManualRegisterForm';
import ReturnedRegistersList from './Areas/ReturnedDrugsRegister/Registers/ReturnedRegistersList';
import CreateReturnedRegisterForm from './Areas/ReturnedDrugsRegister/Registers/forms/CreateReturnedRegisterForm';
import ReturnRegister from './Areas/ReturnedDrugsRegister/Register/ReturnRegister';
import CreateManualReturnedRegisterForm from './Areas/ReturnedDrugsRegister/Registers/forms/CreateManualReturnedRegisterForm';
import { useNavigation } from '@crx-dev/hss-react-infrastructure';
import { ReactComponent as PharmacyOperationsIcon } from './Areas/App/assets/IconPharmacyOperations.svg';
import { useUserInfo } from './Infrastructure/auth/UseUserInfo';
import { logout } from './Infrastructure/auth/keyCloakAuth';
import { useHotkeys } from 'react-hotkeys-hook';
import SettingsPage from './Areas/Settings/SettingsPage';
import { makeReturnUrl } from './Infrastructure/pageState/useMakeReturnUrl';

function App() {
    const navigation = useNavigation();
    const location = useLocation();
    const userInfo = useUserInfo();
    const [userActions, setUserActions] = useState([{ label: 'Logout', onClick: () => logout() }]);
    const history = useHistory();
    const helpUrl = 'https://help.cegedimrx.co.uk/Pharmacy_Operations/Content/Home.htm';

    useHotkeys(
        'F1',
        e => {
            e.preventDefault();
            window.open(helpUrl);
        },
        {
            enableOnTags: ['INPUT']
        }
    );

    const navHelper = (to: string, exact = false) => ({
        to,
        isSelected: !!matchPath(location.pathname, { path: to, exact }),
        onClick: (to: string) => navigation.navigateTo(to)
    });

    useEffect(() => {
        if (window.location.pathname !== '/settings') {
            setUserActions([
                { label: 'Settings', onClick: () => history.push(`/settings?returnUrl=${makeReturnUrl()}`) },
                { label: 'Logout', onClick: () => logout() }
            ]);
        } else {
            setUserActions([{ label: 'Logout', onClick: () => logout() }]);
        }
    }, [window.location.pathname]);

    return (
        <AppContainer
            collapseAt={970}
            logo={<PharmacyOperationsIcon height={100} width={220} />}
            onLogoClick={() => navigation.navigateTo('/')}
            userInfo={{
                name: userInfo.name,
                email: userInfo.email,
                avatar: ''
            }}
            userActions={userActions}
            navigation={
                <>
                    <AppContainer.NavItem label="Controlled Drug Registers" {...navHelper('/', true)} />
                    <AppContainer.NavItem label="Returned Drug Registers" {...navHelper('/returned-registers', true)} />
                    <AppContainer.NavItem label="Help" to={helpUrl} external />
                </>
            }
            content={
                <Switch>
                    <Route exact path="/" component={RegistersList} />
                    <Route exact path="/registers/add" component={CreateRegisterForm} />
                    <Route exact path="/registers/addManual" component={CreateManualRegisterForm} />
                    <Route path="/registers/:registerId" component={Register} />
                    <Route exact path="/returned-registers" component={ReturnedRegistersList} />
                    <Route exact path="/returned-registers/add" component={CreateReturnedRegisterForm} />
                    <Route exact path="/returned-registers/addManual" component={CreateManualReturnedRegisterForm} />
                    <Route path="/returned-registers/:returnedRegisterId" component={ReturnRegister} />
                    <Route path="/settings" component={SettingsPage} />
                </Switch>
            }
        />
    );
}

export default App;
